/**
 * @desc 查询库存主体关系
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockSkuTrandeQty, options?: any) {
  return updateResponse(
    http(URL + `/stock/stockSkuTrandeQty`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
